import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetcheventsRequest,
  fetcheventsSuccess,
  fetcheventsFailure,
  createEventsRequest,
  createEventsFailure,
  createEventsSuccess,
} from "./events.slice.js";
import { API_URL } from "../../../utils/enum.js";

// API function
function* fetcheventsApi() {
  try {
    const token = localStorage.getItem("token");
    const response = yield call(fetch, `${API_URL}/events`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = yield call([response, response.json]);
    yield put(fetcheventsSuccess(data || []));
  } catch (err) {
    yield put(fetcheventsFailure(err.message));
  }
}

function* createEventsApi({payload}) {
  try {
    const token = localStorage.getItem("token");
            const response = yield call(fetch, `${API_URL}/events`, {
              method: "POST",
              headers: {
                 "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ ...payload }),
            });    
    
            if (!response.ok) throw new Error("Folder creation failed");
    const data = yield call([response, response.json]);

    yield put(createEventsSuccess(data || []));
  } catch (err) {
    yield put(createEventsFailure(err.message));
  }
}

// Watcher saga
export function* eventsSaga() {
  yield takeLatest(fetcheventsRequest.type, fetcheventsApi);
  yield takeLatest(createEventsRequest.type, createEventsApi);
}
